module.exports = __webpack_public_path__ + "img/avatar5.528bd3ac.png";